import { useEffect } from 'react';
import type { Quote } from '@/model';

interface UseShopInsuranceAcknowledgmentProps {
  open: boolean;
  isLoading: boolean;
  quotes: Quote[];
  hasAcknowledged: boolean;
  setShowAcknowledgment: (show: boolean) => void;
}

export function useShopInsuranceAcknowledgment({
  open,
  isLoading,
  quotes,
  hasAcknowledged,
  setShowAcknowledgment,
}: UseShopInsuranceAcknowledgmentProps) {
  useEffect(() => {
    if (!open || isLoading || !quotes || quotes.length === 0) {
      return;
    }

    const permanentlyDismissed = localStorage.getItem('shopInsuranceAcknowledgmentDismissed');

    if (!permanentlyDismissed && !hasAcknowledged) {
      setShowAcknowledgment(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, isLoading, quotes, hasAcknowledged]);
}
